import Hyperlink from "@ingka/hyperlink";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import Carousel from "@ingka/carousel";
import { config } from "../../config";
import { getCredentialUrl } from "../../utils";
import {
  getRandomUpcomingEvents,
  useAppContext,
} from "../../contextProviders/AppContext";
import { CSSEvent } from "../../types/model";
import Event from "../../components/Event";
import ConditionalRender from "../../components/ConditionalRender";

const SubHeader = styled.h2`
  color: var(--colour-text-dark);
  margin-bottom: var(--space-75);

  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-100);
  }`}
`;

const Description = styled.p`
  &:not(:last-of-type) {
    margin-bottom: var(--space-200);
    ${({ theme }) => `${theme.breakpoints.lg} {
      max-width: 550px;
      margin-bottom: var(--space-300);
    }`}
  }
`;

const RegisterHeader = styled.h3`
  margin-bottom: var(--space-75);

  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-100);
  }`}
`;

const CarouselWrapper = styled.div`
  margin: var(--space-400) auto;
  .carousel__button {
    z-index: 3;
  }
  .item {
    width: 85%;
    ${({ theme }) => `${theme.breakpoints.md} {
      width: unset;
    }`}
  }
`;

const NoStoreSelected = () => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const randomEvents: Array<CSSEvent> = useSelector(getRandomUpcomingEvents);

  const carouselItems = randomEvents.map((event, i) => (
    <Event event={event} key={i} slideShow={true} />
  ));

  return (
    <>
      <SubHeader>{t("event.joinOurEvents")}</SubHeader>
      <Description>{t("event.noEventsDesc")}</Description>
      <ConditionalRender predicate={randomEvents.length > 0}>
        <CarouselWrapper>
          <Carousel
            children={carouselItems}
            isSlideShow={false}
            slideIndex={0}
            itemClass="item"
          />
        </CarouselWrapper>
      </ConditionalRender>
      <RegisterHeader>{t("event.stayUptoDate")}</RegisterHeader>
      <p>
        <Trans
          i18nKey="event.joinIKEAFamily"
          components={{
            JoinLink: (
              <Hyperlink
                url={getCredentialUrl(config.joinIkeaFamily)}
                text={t("event.joinIKEAFamilyLink")}
              />
            ),
          }}
        />
      </p>
    </>
  );
};

export default NoStoreSelected;
